import React, { FC } from 'react';
import { useTheme, styled, Theme } from '@material-ui/core';
import { ButtonProps as MuiButtonProps } from '@material-ui/core/Button';
import { SvgIcon, Icons } from '../SvgIcon';
import { PrimaryVariantButton } from './PrimaryVariantButton';
import { TextVariantButton } from './TextVariantButton';
import { SecondaryVariantButton } from './SecondaryVariantButton';

export type ButtonVariant = 'primary' | 'secondary' | 'text';

export type ButtonProps = Omit<MuiButtonProps, 'variant'> & {
  icon?: Icons;
  id?: string;
  rounded?: boolean;
  outlined?: boolean;
  variant?: ButtonVariant;
};

const StyledIcon = styled(SvgIcon)<Theme, { hastext: string }>(({ theme, hastext }) => ({
  marginRight: hastext === 'true' ? theme.spacing(1) : undefined,
}));

const Button: FC<ButtonProps> = ({
  children,
  icon,
  rounded = false,
  outlined = false,
  variant = 'primary',
  disabled,
  id,
  ...restProps
}) => {
  const theme = useTheme();
  let buttonVariant: ButtonVariant;

  switch (variant) {
    case 'primary':
    case 'secondary':
    case 'text':
      buttonVariant = variant;
      break;
    default:
      buttonVariant = 'primary';
  }

  return (
    <>
      {
        {
          primary: (
            <PrimaryVariantButton disabled={disabled} id={id} {...restProps}>
              {icon && (
                <StyledIcon
                  color={disabled ? theme.palette.grey['500'] : theme.palette.common.white}
                  icon={icon}
                  hastext={(!!children).toString()}
                />
              )}
              {children}
            </PrimaryVariantButton>
          ),
          secondary: (
            <SecondaryVariantButton disabled={disabled} id={id} {...restProps}>
              {icon && (
                <StyledIcon
                  color={disabled ? theme.palette.grey['500'] : theme.palette.common.white}
                  icon={icon}
                  hastext={(!!children).toString()}
                />
              )}
              {children}
            </SecondaryVariantButton>
          ),
          text: (
            <TextVariantButton disabled={disabled} id={id} {...restProps}>
              {icon && (
                <StyledIcon
                  color={disabled ? theme.palette.grey['500'] : theme.palette.grey['700']}
                  icon={icon}
                  hastext={(!!children).toString()}
                />
              )}
              {children}
            </TextVariantButton>
          ),
        }[buttonVariant]
      }
    </>
  );
};

export default Button;
